module.exports = __webpack_public_path__ + "static/accordionwithouticon-13d9b1b24435552e318befdaa0dbc3d9.png";